module.exports = __webpack_public_path__ + "static/img/share1.6939c7c7.png";